import { ResourceEntity } from '@/graphql/generated/graphql';
import { fetchTrendingResources } from '@/services/knowledge-hub/knowledge-hub.service';
import { useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEmotionWheelStore } from '../store/useEmotionWheelStore';
import { useHomeStore } from '@/pages/home/useHome';

export function useEmotionWheel() {
  const { onInit } = useEmotionWheelStore();
  const navigate = useNavigate();
  const { dailyEmotionWheelCompleted } = useHomeStore();
  const [youMayAlso, setYouMayAlso] = useState<ResourceEntity[]>([]);

  useLayoutEffect(() => {
    onInit();
    async function getYouMayAlso() {
      const latests = await fetchTrendingResources(2);

      if (latests.resources === null) {
        return;
      }

      if (latests.resources!.length! > 0) {
        setYouMayAlso(latests.resources as ResourceEntity[]);
      }
    }

    getYouMayAlso();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    navigate,
    dailyEmotionWheelCompleted,
    youMayAlso,
  };
}
